class CustomError extends Error {
  override readonly cause?: unknown;
  override readonly message: string;
  override readonly name: string;
  nodeError?: Error;
  railsError?: Error;
  override readonly stack?: string;

  constructor(message: string, cause?: unknown) {
    super(message);
    this.name = this.constructor.name;
    this.message = message;
    this.stack = new Error(message).stack;
    this.cause = cause;
  }
}

export class BothUserError extends CustomError {
  constructor(cause?: Error, nodeError?: Error, railsError?: Error) {
    super('Failed to fetch both users', cause);
    this.nodeError = nodeError;
    this.railsError = railsError;
  }
}

export class NodeUserError extends CustomError {
  constructor(cause?: Error) {
    super('Fetch secondary user failed', cause);
  }
}

export class RailsUserError extends CustomError {
  constructor(cause?: Error) {
    super('Fetch primary user failed', cause);
  }
}
